module.exports = __webpack_public_path__ + "img/3.587406a2.png";